
import { useState, useEffect } from 'react';

export default function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      className={`fixed bottom-20 sm:bottom-8 right-4 sm:right-6 z-40 w-11 h-11 sm:w-12 sm:h-12 bg-[#E10600] text-white rounded-full shadow-lg hover:bg-[#B80500] transition-all duration-300 cursor-pointer flex items-center justify-center ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      aria-label="Powrót do góry"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}
